import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { PRIMARY, TEXT, INTERACTIVE } from "../../styles/colors";

export const HeaderSection = styled("header")`
  padding: 1rem 0.5rem;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const LogoText = styled("h1")`
  font-size: 2rem;
  font-weight: 700;
  color: ${TEXT.primary};
  margin: 0;
  font-family: "Motiva Sans", sans-serif;
  
  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
  
  @media only screen and (max-width: 890px) {
    display: block;
    text-align: left;
  }
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: ${PRIMARY.main};
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1rem;
  color: ${TEXT.primary};
  transition: color 0.2s ease-in;
  margin: 0.4rem 1rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: ${TEXT.secondary};
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: ${INTERACTIVE.hover};
    text-underline-position: under;
    text-decoration: ${INTERACTIVE.hover} wavy underline;
  }
`;
